export enum Language {
  English = "en",
  German = "de",
  French = "fr",
  Spanish = "es",
  Italian = "it",
  Portuguese = "pt",
  Chinese = "zh",
}

export enum Device {
  Desktop = "desktop",
  Mobile = "mobile",
}
